import ThemeLinkButton from './ThemeLinkButton';

export default ThemeLinkButton;
export { ThemeLinkButton };
